import React from "react";
import { object } from "prop-types";
import flatten from "lodash/flatten";

import Carousel from "../../atoms/carousel";
import Headline from "../../atoms/headline";
import LinkButton from "../../atoms/link-button";
import CardImageType2 from "../card-image-type-2";

import "./home-carousel.m.css";

const HomeCarousel = ({ collection, options }) => {
  const storiesFromCollection = collection.items.filter(item => item.type === "story");
  const children = storiesFromCollection
    .map(({ story }, key) => {
      // Pick only the story images from the card
      const cardImagesList =
        story.cards &&
        story.cards.length &&
        story.cards.map(card => card["story-elements"].filter(storyElement => storyElement.type === "image"));

      // If card doesn't have any images then neglect it
      if (!(cardImagesList && cardImagesList.length)) {
        return null;
      }

      const imageList = flatten(cardImagesList);

      // If card doesn't have any images then neglect it
      if (!(imageList && imageList.length)) {
        return null;
      }

      // Fetch random image from the image list
      const image = imageList[Math.floor(Math.random() * imageList.length)];

      // To link a carousel story to an external URL, match its slug and set the target URL
      const FESTIVAL_STORY_SLUG = "other/ncf-turns-30-come-celebrate-with-us";
      const FESTIVAL_EXTERNAL_URL = "https://ncf30years.org";
      const getSectionSlug = (story.sections && story.sections[0].slug) || "";
      const linkUrl = story.slug === FESTIVAL_STORY_SLUG ? FESTIVAL_EXTERNAL_URL : `/${getSectionSlug}`;

      // First slide (index 0) is the festival banner - use higher opacity for its text box
      const isFirstSlide = key === 0;

      return (
        <div styleName="content-wrapper" key={key}>
          {story && <CardImageType2 image={image} />}
          <div styleName={`content${isFirstSlide ? " content-festival" : ""}`}>
            <Headline text={story.headline} headerLevel={2} headerType={4} />
            {story.subheadline && <p styleName="description">{story.subheadline}</p>}
            {linkUrl && <LinkButton slug={linkUrl} />}
          </div>
        </div>
      );
    })
    .filter(story => story); // Remove story objects which are null

  return (
    <div>
      <Carousel
        carouselName={`carousel-${collection.slug}`}
        options={options}
        showDots={true}
        totalItems={storiesFromCollection.length}
      >
        {children}
      </Carousel>
    </div>
  );
};

export default HomeCarousel;

HomeCarousel.propTypes = {
  collection: object.isRequired,
  options: object.isRequired
};
